<template>
<div class='mask' @click.self='close'>
  <div class='body'>
    <h2>{{attendee.firstName}} {{attendee.lastName}}</h2>
    <h4>Email</h4>
      <span>{{attendee.email}}</span>
    <h4>Phone</h4>
      <span>{{attendee.phone}}</span>
    <h4>Track</h4>
      <span>{{attendee.track}}</span>
    <h4>Authenticated</h4>
      <span>{{attendee.authenticated}}</span>
    <h4>Access Codes</h4>
      <ul>
        <li v-for='code in attendee.accessCodes'>{{code.code}}</li>
      </ul>
    <div>
      <input type='button' @click='addCode()' value='Create Code' class='dark' />
    </div>
  </div>

</div>
</template>

<script>
export default {
  props: {
    attendee: {
      default: null
    }
  },
  methods: {
    close(){
      this.$emit('close')
    },
    addCode(){
      this.$store.dispatch('attendees/createAccessCode', {id: this.attendee.id})
    },
  },
  computed: {}
};
</script>

<style scoped lang='scss'>
.mask {
  width: 100vw;
  height: 100vh;
  background: hsla(0, 0%, 0%, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.body {
  width: 60vw;
  min-width: 800px;
  background: $gray-1;
  padding: 12px 32px;
  max-height: 80vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/event/attendeeDetail.vue